import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { backend_domain } from "../../helpers";

const HeroBanner = ({ homeData }) => {
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
        style={{ position: "absolute", top: "50%", right: "1%", zIndex: 99 }}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
        style={{ position: "absolute", top: "50%", left: "1%", zIndex: 99 }}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <div className="banner">
      <div className="container container-lg">
        <div style={{ position: "relative" }}>
          {/* <a
            href="#featureSection"
            className="scroll-down w-84 h-84 text-center flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-800"
          >
            <span className="icon line-height-0">
              <i className="ph ph-caret-double-down" />
            </span>
          </a> */}

          {/* <img
            src="/assets/images/bg/banner-bg.png"
            alt=""
            className="banner-img position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 object-fit-cover rounded-24"
          /> */}
          <div className="flex-align"></div>
          <div className="banner-slider">
            <Slider {...settings}>
              {homeData?.banners?.length > 0 &&
                homeData?.banners?.map((item, index) => (
                  <div className="h-100 banner-slider__item">
                    <div className="banner-slider__inner flex-between position-relative">
                      <img
                        key={index}
                        src={`${backend_domain}${item?.image}`}
                        alt=""
                        className="w-100 rounded-24 img-fluid"
                        style={{ height: "550px" }}
                      />
                    </div>
                  </div>
                ))}
              {/* <div className="banner-slider__item">
                <div className="banner-slider__inner flex-between position-relative">
                  <div className="banner-item__content">
                    <h1 className="banner-item__title bounce">
                      KITCHEN EQUIPMENTS
                    </h1>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Quaerat deserunt facere excepturi nihil eligendi laborum
                      necessitatibus doloremque iste nisi in quis fuga placeat
                      doloribus vero illum voluptatem et quas, quae id delectus?
                      Blanditiis, similique!
                    </p>
                    <Link
                      to="/shop"
                      className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8 mt-30"
                    >
                      Explore Shop{" "}
                      <span className="icon text-xl d-flex">
                        <i className="ph ph-shopping-cart-simple" />{" "}
                      </span>
                    </Link>
                  </div>
                  <div className="banner-item__thumb">
                    <img src="assets/images/thumbs/banner-img1.png" alt="" />
                  </div>
                </div>
              </div>
              <div className="banner-slider__item">
                <div className="banner-slider__inner flex-between position-relative">
                  <div className="banner-item__content">
                    <h1 className="banner-item__title bounce">
                      KITCHEN EQUIPMENTS
                    </h1>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Quaerat deserunt facere excepturi nihil eligendi laborum
                      necessitatibus doloremque iste nisi in quis fuga placeat
                      doloribus vero illum voluptatem et quas, quae id delectus?
                      Blanditiis, similique!
                    </p>
                    <Link
                      to="/shop"
                      className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8"
                    >
                      Explore Shop{" "}
                      <span className="icon text-xl d-flex">
                        <i className="ph ph-shopping-cart-simple" />{" "}
                      </span>
                    </Link>
                  </div>
                  <div className="banner-item__thumb">
                    <img src="assets/images/thumbs/banner-img3.png" alt="" />
                  </div>
                </div>
              </div> */}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
